















import Vue from 'vue'
import Login from '../components/Login.vue'
import AppInfo from '../components/AppInfo.vue'
import AppInstall from '../components/AppInstall.vue'
import Features from '../components/Features.vue'
import store from '../store'
require('animate.css')

export default Vue.extend({
  name: 'App',
  components: {
    Login,
    AppInfo,
    Features,
    AppInstall
  },
  mounted () {
  },
  computed: {
    stepIs () {
      return store.state.stepIs
    }
  }
})
